import React from 'react';
import CaremapprConfirmation from '../../../components/Confirmation/CaremapprConfirmation';
import { useMedicationProfileDirty } from '../context/MedicationProfileDirtyProvider';

interface CloseButtonProps {
  onClick: () => void;
}
const CloseButton = ({ onClick }: CloseButtonProps) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = React.useState(false);
  const { isDirty } = useMedicationProfileDirty();
  const handleClick = () => {
    if (isDirty) {
      setIsConfirmationOpen(true);
      return;
    }
    onClick();
  };
  return (
    <>
      <button
        type="button"
        className="btn-close"
        onClick={handleClick}
        aria-label="Close Medication Profile"
      ></button>
      <CaremapprConfirmation
        open={isConfirmationOpen}
        text="This operation will reset unsaved values. Are you sure?"
        icon="warning"
        onConfirm={() => {
          onClick();
        }}
        onClose={() => setIsConfirmationOpen(false)}
        showCancelButton
      />
    </>
  );
};

export default CloseButton;
